import { render } from "./MenuPartners.vue?vue&type=template&id=6e2936ed&ts=true"
import script from "./MenuPartners.vue?vue&type=script&lang=ts"
export * from "./MenuPartners.vue?vue&type=script&lang=ts"

import "./MenuPartners.vue?vue&type=style&index=0&id=6e2936ed&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__